import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core";
import { Media } from "../models/Media";
import CustomImage from "./CustomImage";
import CustomVideoPlayer from "./CustomVideoPlayer";

const MediaWidget = ({ media, onClick, style, enablePreview = false }) => {
  const classes = makeStyles(() => ({
    thumbnail: {
      width: "100%",
      height: 200,
      minHeight: 200,
      objectFit: "cover",
      borderRadius: 15,
    },
  }))();

  const renderMedia = () => {
    switch (media?.type) {
      case Media.types.image:
        return (
          <CustomImage
            src={media?.src}
            style={style}
            className={classes.thumbnail}
            onClick={onClick}
            enablePreview={enablePreview}
          />
        );

      case Media.types.video:
        return (
          <CustomVideoPlayer
            src={media?.src}
            style={style}
            className={classes.thumbnail}
            onClick={onClick}
            enablePreview={enablePreview}
          />
        );

      default:
        return <Fragment />;
    }
  };

  return <>{renderMedia()}</>;
};

export default MediaWidget;
